<template>
  <div v-loading="pageLoading">
    <div>
      <!-- 搜索 -->
      <el-form :inline="true" :model="msg" class="demo-form-inline">
        <el-form-item label="職員編號">
          <el-input
            v-model="msg.workNo"
            placeholder="請輸入職員編號"
          ></el-input>
        </el-form-item>
        <el-form-item label="課程名稱">
          <el-input v-model="msg.courseName" placeholder="請輸入課程名稱"></el-input>
        </el-form-item>
        <!-- <el-form-item label="章節名稱">
          <el-input v-model="msg.sectionName"></el-input>
        </el-form-item> -->
        <el-form-item label="反饋名稱">
          <el-input v-model="msg.ueviomsName" placeholder="請輸入反饋名稱"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn" @click="onSubmit">搜尋</el-button>
          <el-button type="primary" @click="setTemplate"
            >新增題目範本</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="線上課程" name="1">
          <el-table
            ref="singleTable"
            :data="tableData1"
            empty-text="暫無記錄"
            style="width: 100%"
            border
            @sort-change="sort"
          >
            <el-table-column
              type="index"
              label="序號"
              width="120"
            ></el-table-column>
            <el-table-column
              sortable="custom"
              property="workNo"
              width="135"
              label="職員編號"
            ></el-table-column>
            <el-table-column
              property="courseName"
              label="課程名稱"
            ></el-table-column>
            <el-table-column
              property="ueviomsName"
              label="反饋名稱"
            ></el-table-column>
            <el-table-column
              property="manUserName"
              label="創建人"
            ></el-table-column>
            <el-table-column
              property="sectionName"
              label="章節名稱"
            ></el-table-column>
            <el-table-column
              property="allNum"
              label="總人數"
              sortable="custom"
            ></el-table-column>
            <el-table-column label="操作" width="145">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="view(scope.row, 1)"
                  >查看意見詳情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :hide-on-single-page="true"
            :total="total1"
            layout="prev, pager, next,total"
            @current-change="pageChange"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="線下課程" name="2">
          <el-table
            ref="singleTable"
            :data="tableData2"
            empty-text="暫無記錄"
            style="width: 100%"
            border
            @sort-change="sort"
          >
            <el-table-column
              type="index"
              label="序號"
              width="120"
            ></el-table-column>
            <el-table-column
              sortable="custom"
              property="workNo"
              width="135"
              label="職員編號"
            ></el-table-column>
            <el-table-column
              property="courseName"
              label="課程名稱"
            ></el-table-column>
            <el-table-column
              property="ueviomsName"
              label="反饋名稱"
            ></el-table-column>
            <el-table-column
              property="manUserName"
              label="創建人"
            ></el-table-column>
            <el-table-column
              property="sectionName"
              label="章節名稱"
            ></el-table-column>
            <el-table-column
              property="allNum"
              label="總人數"
              sortable="custom"
            ></el-table-column>
            <el-table-column label="操作" width="145">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="view(scope.row, 2)"
                  >查看試卷詳情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :hide-on-single-page="true"
            :total="total2"
            layout="prev, pager, next,total"
            @current-change="pageChange"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="直播課程" name="3">
          <el-table
            ref="singleTable"
            empty-text="暫無記錄"
            :data="tableData3"
            style="width: 100%"
            border
            @sort-change="sort"
          >
            <el-table-column
              type="index"
              label="序號"
              width="120"
            ></el-table-column>
            <el-table-column
              sortable="custom"
              property="workNo"
              width="135"
              label="職員編號"
            ></el-table-column>
            <el-table-column
              property="courseName"
              label="課程名稱"
            ></el-table-column>
            <el-table-column
              property="ueviomsName"
              label="反饋名稱"
            ></el-table-column>
            <el-table-column
              property="manUserName"
              label="創建人"
            ></el-table-column>
            <el-table-column
              property="sectionName"
              label="章節名稱"
            ></el-table-column>
            <el-table-column
              property="allNum"
              label="總人數"
              sortable="custom"
            ></el-table-column>
            <el-table-column label="操作" width="145">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="view(scope.row, 3)"
                  >查看試卷詳情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :hide-on-single-page="true"
            :total="total3"
            layout="prev, pager, next,total"
            @current-change="pageChange"
          ></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageLoading: false,

      msg: {
        names: "",
        workNo: "",
        courseName: "",
        // sectionName: "",
        ueviomsName: "",
        pageSize: 10,
        pageNum: 1,
        sortAsc: "",
        sortDesc: "",
        type: "1",
      },
      form: {
        region: "",
        filiale: "",
        department: "",
      },
      formLabelWidth: "80px",
      tableData1: [],
      tableData2: [],
      tableData3: [],
      activeName: "1",
      total1: 0,
      total2: 0,
      total3: 0,
    };
  },
  mounted() {
    $("#pageHead").text("課程意見");
  },
  methods: {
    onSubmit() {
      this.msg.pageNum = 1;
      this.getList();
    },
    sort(msg) {
      // 排序
      var prop = msg.prop,
        order = msg.order,
        query = this.msg;
      if (order == "ascending") {
        query.sortDesc = prop;
        query.sortAsc = "";
      } else {
        query.sortDesc = "";
        query.sortAsc = prop;
      }
      query.pageNum = 1;
      this.getList();
    },
    pageChange(val) {
      // 切換頁碼
      this.msg.pageNum = val;
      this.getList();
    },
    view(row, type) {
      row["type"] = type;
      sessionStorage.assessmentDetails = JSON.stringify(row);
      this.$router.push("/home/assessmentDetails");
    },
    setTemplate() {
      this.$router.push({
        name: "assessmentTemplate",
      });
    },
    getList() {
      var msg = this.utils.filtration(this.msg);
      this.pageLoading = true
      this.axios
        .get("/manage/getCourseEvaluationList", {
          params: msg,
        })
        .then((res) => {
          if (res) {
            let result = res.result,
              type = msg.type;
            if (type == 1) {
              this.tableData1 = result;
              this.total1 = res.total;
            } else if (type == 2) {
              this.tableData2 = result;
              this.total2 = res.total;
            } else if (type == 3) {
              this.tableData3 = result;
              this.total3 = res.total;
            }
          }
          this.pageLoading = false
        }).catch(() => {
          this.pageLoading = false
        })
    },
    handleClick(tab) {
      this.msg.type = tab.name;
      this.getList();
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style scoped>
.btn {
  margin-left: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
}
/deep/ .el-form-item__label {
  width: 80px;
}
</style>
